{
  "utcClock": "현재 시각 (UTC)",
  "clockSkew": "기기 시계",
  "clockSkewMeasuring": "측정 중",
  "clockSkewOffline": "연결 없음",
  "clockSkewOfflineDeviceClock": "연결 없음, 보정 안 됨",
  "remainingIdle": "T− --:--",
  "remainingLabel": "남은 시간",
  "typeAttack": "attack",
  "typeDefense": "defense",
  "typeUnset": "타입 미정",
  "summaryEmpty": "ops 없음",
  "langSwitch": "표시 언어",
  "remainingAllOpen": "개시 끝",
  "bandAttackCount": "rally {n} 줄",
  "bandAttackNext": "rally {n} 줄, 다음 {roster} {offset}",
  "bandDefenseCount": "적 rally {n}",
  "bandNeedCode": "관리 코드 필요",
  "bandOtherTab": "다른 탭에서 사용 중"
}
